import { useContext } from "react";
import { ConfirmContext } from "context/confirm-context";

const useConfirm = () => {
  const [confirm, setConfirm] = useContext(ConfirmContext);

  const isConfirmed = ({ title, description, approveText, rejectText }) => {
    const promise = new Promise((resolve, reject) => {
      setConfirm({
        isOpen: true,
        proceed: resolve,
        cancel: reject,
        title: title || "",
        description: description || "",
        approveText: approveText || "Yes",
        rejectText: rejectText || "No",
      });
    });
    return promise.then(
      () => {
        setConfirm({ ...confirm, isOpen: false });
        return true;
      },
      () => {
        setConfirm({ ...confirm, isOpen: false });
        return false;
      }
    );
  };
  return {
    ...confirm,
    isConfirmed,
  };
};

export default useConfirm;
